import _ from 'lodash';
import type { EndpointActions, IEndpointConfigState, ISetValuePayload } from './EndpointContext';
import { EndpointActionTypes } from './EndpointContext';

export const EndpointReducer = (state: IEndpointConfigState, action: EndpointActions): IEndpointConfigState => {
  switch (action.type) {
    case EndpointActionTypes.INIT_ENDPOINT_CONFIG:
      return {
        ...action.payload
      };
    case EndpointActionTypes.SET_VALUE:
      return setEndpointConfig(state, action.payload);
    case EndpointActionTypes.UNSET_VALUE:
      return unSetEndpointConfig(state, action.payload);
    default:
      return state;
  }
};

const setEndpointConfig = (state: IEndpointConfigState, payload: ISetValuePayload) => {
  const stateCopy = _.cloneDeep(state);
  if (payload.value === undefined || payload.value === '') {
    _.unset(stateCopy.schema, payload.key);
  } else {
    _.set(stateCopy.schema, payload.key, payload.value);
  }

  return stateCopy;
};

const unSetEndpointConfig = (state: IEndpointConfigState, payload: { key: string[] }) => {
  const stateCopy = _.cloneDeep(state);
  _.unset(stateCopy.schema, payload.key);

  return stateCopy;
};
